export default __webpack_public_path__ + "static/media/guide_me@2x.b305d500.png";